import { Dispatch } from "redux";

import {
  ERROR_LOADING_TAGS,
  GET_ALL_TAGS,
  RESET_DATA,
  START_LOADING_TAGS,
  STOP_LOADING_TAGS,
} from "./action-types";

import apiLibrary from "services/api";
import { generateQueryStringForUsers } from "utils/convertFiltersToQueryString";
import { Toasts } from "view/components/Toasts";

export const fetchTagsAction =
  () => async (dispatch: Dispatch, getState: any) => {
    dispatch({ type: START_LOADING_TAGS });
    try {
      const currentState = getState();
      const queryString = generateQueryStringForUsers(
        currentState.Filters.tagsFilter
      );
      const { data } = await apiLibrary.Tagging.getAllTags(queryString);
      dispatch({
        type: GET_ALL_TAGS,
        payload: data,
      });
    } catch (error: any) {
      const errorMsg = error?.response?.data?.message ?? error?.message;
      Toasts.error(errorMsg);
      dispatch({
        type: RESET_DATA,
      });
      console.log("An error occurred while fetching the user profile:", error);
      dispatch({ type: ERROR_LOADING_TAGS });
      // dispatch(fetchError(error))
    } finally {
      dispatch({ type: STOP_LOADING_TAGS });
      // dispatch(loadingState(false))
    }
  };
